import { render, staticRenderFns } from "./JieJiaRi.vue?vue&type=template&id=1f25be19&scoped=true&"
import script from "./JieJiaRi.vue?vue&type=script&lang=js&"
export * from "./JieJiaRi.vue?vue&type=script&lang=js&"
import style0 from "./JieJiaRi.vue?vue&type=style&index=0&id=1f25be19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f25be19",
  null
  
)

export default component.exports